export const urlsubscribe = () => {
    let url = '';
    switch (document.location.hostname) {
        case 'www.kommunal-rapport.no':
        // fallthru
        case 'www-stage.kommunal-rapport.no':
        // fallthru
        case 'https://www-kr-labcluster-espena.labdevs.com':
        // fallthru
        default:
            url = "https://order.mediaconnect.no/kommunal-rapport/KBD/userform?couponNumber=101";
    }
    return url;
};
